import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { SearchParamsBoards } from "../user/user";

@Injectable()
export class SearchParamsBoardsProvider {
  private SEARCH_PARAMS_KEY_BOARDS: string = "pv-search-params-boards";
  private searchParamsBoards: SearchParamsBoards;

  constructor(public storage: Storage) {}

  initialParamsBoards(): SearchParamsBoards {
    let date: string = new Date().toISOString();
    // NOTE "YYYY-MM-dd"　に整形
    date = date.substring(0, date.indexOf("T"));
    this.searchParamsBoards = <SearchParamsBoards>{
      date: null,
      board_areas: [],
      board_purposes: "all",
      age: { min_range: undefined, max_range: undefined },
      lookses: [],
      body_types: [],
      sort_by: null,
    };
    return this.searchParamsBoards;
  }

  async getBoardsParams(): Promise<SearchParamsBoards> {
    if (this.searchParamsBoards) return this.searchParamsBoards;
    this.searchParamsBoards = await this.storage.get(
      this.SEARCH_PARAMS_KEY_BOARDS
    );
    return this.searchParamsBoards;
  }

  setBoards(params: SearchParamsBoards): Promise<any> {
    this.searchParamsBoards = params;
    return this.storage.set(this.SEARCH_PARAMS_KEY_BOARDS, params);
  }

  async setParam(paramId: string, value: any): Promise<any> {
    const params: SearchParamsBoards = await this.getBoardsParams();
    params[paramId] = value;
    this.searchParamsBoards = params;
    return this.setBoards(params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/search-params-boards/search-params-boards.ts